import { api } from "@/client/api";
import { ClerkWrapper } from "@/client/components/clerk-wrapper";
import { Shell } from "@/client/components/shell";
import { DatadogLogs } from "@/client/datadog-logs";
import { createTheme, Group, MantineProvider, Stack } from "@mantine/core";

import "@mantine/core/styles.css";

import { Notifications } from "@mantine/notifications";
import { IconFishBoneFilled } from "@tabler/icons-react";
import { Analytics } from "@vercel/analytics/react";
import type { AppType } from "next/app";
import dynamic from "next/dynamic";
import Head from "next/head";

const theme = createTheme({
  respectReducedMotion: true,
  components: {
    Group: Group.extend({
      defaultProps: {
        gap: "sm",
      },
    }),
    Stack: Stack.extend({
      defaultProps: {
        gap: "sm",
      },
    }),
  },
});

const MyApp: AppType = ({ Component, pageProps: { ...pageProperties } }) => {
  const AnyComponent = Component as any;
  return (
    <MantineProvider theme={theme}>
      <ClerkWrapper>
        <Analytics />
        <DatadogLogs />
        <Notifications />
        <Shell icon={<IconFishBoneFilled />}>
          <Head>
            <title>remora.sh</title>
            <meta
              name="description"
              content="Find high quality candidates from Hacker News for your startup."
            />
            <meta property="og:title" content="remora.sh" />
            <meta
              property="og:description"
              content="Find high quality candidates from Hacker News for your startup."
            />
          </Head>
          <AnyComponent {...pageProperties} />
        </Shell>
      </ClerkWrapper>
    </MantineProvider>
  );
};

export default dynamic(() => Promise.resolve(api.withTRPC(MyApp)), {
  ssr: false,
});
